import {useEffect,useState} from 'react';
import { useNavigate ,useParams} from "react-router-dom";


import Typography from '@mui/material/Typography';
import Breadcrumbs from '@mui/material/Breadcrumbs';
import Link from '@mui/material/Link';
import Divider from '@mui/material/Divider';
import { Button } from "@mui/material";
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import TextField from '@mui/material/TextField';
import SendIcon from '@mui/icons-material/Send';
import SaveIcon from '@mui/icons-material/Save';
import EditIcon from '@mui/icons-material/Edit';
import Box from '@mui/material/Box';
import Alert from '@mui/material/Alert';

import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import CircularProgress from '@mui/material/CircularProgress';

import TopPrivateNavigation from '../components/TopPrivateNavigation.jsx'
import AppLogout from '../components/AppLogout.jsx'

import SmartPortionComponent from '../components/SmartPortion.jsx'

//services
import AuthService from '../service/auth'
import SettingsService from '../service/Settings'
import FoodService from '../service/Food'
import ProjectService from '../service/Project'
import MeasurementService from '../service/Measurement'
import SmartPortionService from '../service/SmartPortion'


function formatJson(json){
	return JSON.stringify(json);
}

function formatFractions(volume,fraction){
	if(fraction=="1"){
		return volume;
	}else{
		let s =fraction.split('/')
		return (volume/s[1])*s[0];
	}
}

const Food = () => {
	
	const navigate = useNavigate();
	//protected page check if logged in
	const [globalSettings,setGlobalSettings]=useState({});//global config
	const [globalSettingsLoaded,setGlobalSettingsLoaded]=useState(false);//global config
	const [modulesEnabled,setModulesEnabled]=useState({'questionnaires':false,'recipes':false,'smart_portions':false});
	const [currentUser,setCurrentUser]=useState({});
	const [devMode,setDevMode]=useState({});
	const [projectData,setProjectData]=useState([]);
	const [projectFound,setProjectFound]=useState(false);
	
	//let params = useParams();
	let project_id =ProjectService.getCurrentProject();//params.id;
	////console.log('project_id',project_id);
	
	const [foodData,setFoodData]=useState([]);//used for view/edit
	const [tempFoodData,setTempFoodData]=useState({});//used for new
	const [foodFound,setFoodFound]=useState(false);
	const [foodTranslations,setFoodTranslations]=useState(false);
	const [smartPortionData,setSmartPortionData]=useState([]);//used for view/edit
	let params = useParams();
	let food_id =params.id;
	//console.log('food_id',food_id);
	const [foodId,setFoodId]=useState(food_id);
	
	let method =params.method;
	//console.log('method',method);
	const [methodType,setMethodType]=useState(method.charAt(0).toUpperCase() + method.slice(1));
	
	const [ShowErrorMessage,setErrorStatus]=useState(false); 
	const [ErrorText,setErrorMessage]=useState(""); 
	
	const [ShowSuccessMessage,setSuccessStatus]=useState(false); 
	const [SuccessText,setSuccessMessage]=useState("");
		
	useEffect(() => {
		
		let _loggedInStatus = AuthService.getUserLoggedInStatus();
		if(_loggedInStatus.loggedIn){
			
			setCurrentUser(AuthService.getCurrentUser());
			setDevMode(AuthService.isDevMode());
			SettingsService.getAllFormatted().then(function(res){
				let _globalSettings=res.data;
				setGlobalSettings(res.data);
				setGlobalSettingsLoaded(true);
				console.log(res.data);
				
				var account_type=AuthService.getCurrentUser().__t;
				console.log('account_type',account_type);
				
				if(typeof _globalSettings.modules!=="undefined"){
					
					//update local modules enabled variables
					setModulesEnabled({
						'questionnaires':_globalSettings.modules.settings.questionnaires.on,
						'recipes':_globalSettings.modules.settings.recipes.on,
						'smart_portions':_globalSettings.modules.settings.smart_portions.on
					});
			
				}
				//load project if set 
				if((typeof project_id !=="undefined")&&(project_id!==null)){//project filter
					loadProjectById(project_id);
				}
				
				if((typeof project_id !=="undefined")&&(project_id!==null)){//project filter
								loadProjectById(project_id);
							}
							loadFoodTranslation();
							loadFoodGroups();
							if(methodType=='New'){
								
							}else if(methodType=='Edit'){
								loadFoodById(food_id);
							}else if(methodType=='View'){
								loadFoodById(food_id);
								
							}else if(methodType=='Clone'){
								loadFoodById(food_id);
								
							}else if(methodType=='Copy'){
								loadFoodById(food_id);
								
							}else if(methodType=='Approve'){
								loadFoodById(food_id);
								
							}
							
							
							//load
							if(account_type=='Admin'){//Admin
						
							}else if(account_type=='Master'){//Master
							
								
							}else if(account_type=='Researcher'){//Researcher
			 				
							}
				
				//load by account type
				if(account_type=='Admin'){//Admin
							
				}else if(account_type=='Master'){//Master
							
								
				}else if(account_type=='Researcher'){//Researcher
								
				}

			}).catch(function(error){
				console.log(error);
			});
			
		}else{
			navigate(_loggedInStatus.redirectUrl);
		}
		{/*if(!AuthService.isUserLoggedIn()){
			// not logged in navigate back to login
			navigate("/login");
		}else{
				setCurrentUser(AuthService.getCurrentUser());
				var account_type=AuthService.getCurrentUser().__t;
				console.log('account_type',account_type);
				
				console.log(AuthService.getCurrentUser());
				var currentUser=AuthService.getCurrentUser();
				//expired Account
				if(currentUser.expired){
					var string = "account_type="+AuthService.getCurrentUser().__t+"&type=expired";
					console.log('string',string);
					var encodedString = btoa(string); // Base64 encode the String
					console.log('encodedString',encodedString);
					navigate("/restricted/"+encodedString);
					
				}else{//unverified account
					if(!currentUser.email_verified){
						var string = "account_type="+AuthService.getCurrentUser().__t+"&type=emaiverification";
						console.log('string',string);
						var encodedString = btoa(string); // Base64 encode the String
						console.log('encodedString',encodedString);
						navigate("/restricted/"+encodedString);
						
					}else{////force chan ge Password
						if(currentUser.force_password_change){
								
						
						}else{
							if((typeof project_id !=="undefined")&&(project_id!==null)){//project filter
								loadProjectById(project_id);
							}
							loadFoodTranslation();
							loadFoodGroups();
							if(methodType=='New'){
								
							}else if(methodType=='Edit'){
								loadFoodById(food_id);
							}else if(methodType=='View'){
								loadFoodById(food_id);
								
							}else if(methodType=='Clone'){
								loadFoodById(food_id);
								
							}else if(methodType=='Copy'){
								loadFoodById(food_id);
								
							}else if(methodType=='Approve'){
								loadFoodById(food_id);
								
							}
							
							
							//load
							if(account_type=='Admin'){//Admin
						
							}else if(account_type=='Master'){//Master
							
								
							}else if(account_type=='Researcher'){//Researcher
			 				
							}
						}
					}
				}	
	}*/}
	}, []);
	
	function loadFoodById(food_id){
			FoodService.getById(food_id).then(function(res){
				var _food=res.data;
				console.log('food',_food);
				loadSmartPortion(_food.code);
				
				//New Edit View Clone Copy Approve
				if(['Copy','Clone'].includes(methodType)){
					delete _food['_id']; 
					//delete _food['code']; 
				}

				setFoodData(_food);
				setFoodFound(true);
			}).catch(function(error){
					console.log(error);
					setFoodFound(false);
			});
		}
		
	
		
	function loadFoodTranslation(){
			FoodService.getTranslations().then(function(res){
				setFoodTranslations(res.data);
				console.log(res.data);
				createTemplate(res.data);
			}).catch(function(error){
					console.log(error);
			});
		}
	
	const [foodGroups,setFoodGroups]=useState([]);	
	function loadFoodGroups(){
			FoodService.getFoodGroups().then(function(res){
				setFoodGroups(res.data);
				console.log(res.data);
			}).catch(function(error){
					console.log(error);
			});
	}
	
	const [smartPortion,setSmartPortion]=useState({});	
	const [smartPortionLoaded,setSmartPortionLoaded]=useState(false);	
	function loadSmartPortion(food_code){
			SmartPortionService.getByFoodCode(food_code).then(function(res){
				setSmartPortion(res.data);
				console.log(res.data);
				setSmartPortionLoaded(true);
			}).catch(function(error){
					console.log(error);
			});
	}
	
	const [openSmartPortionDialog, setOpenSmartPortionDialog] = useState(false);

	  const handleClickSmartPortionOpen = () => {
		setOpenSmartPortionDialog(true);
	  };

	  const handleSmartPortionClose = () => {
		setOpenSmartPortionDialog(false);
	  };
	
	
	const removeKeys=function(object,keys){
		var obj={};
		for (let key in object) {
		  if(!keys.includes(key)){
			  obj[key]=object[key];
		  }
		}
		return obj;
	}
	
	function loadProjectById(project_id){
			ProjectService.getById(project_id).then(function(res){
				setProjectData(res.data);
				console.log(res.data);
				setProjectFound(true);
			}).catch(function(error){
					console.log(error);
					setProjectFound(false);
			});
		}
		
	const handleOnChangeValue = (e,key) => {
		console.log(e.target.value,key);
		
		setFoodData({...foodData,
			[key]: e.target.value,
		})
	};
	
	const [validCode,setValidCode]=useState(false);
	const handleOnChangeCode = (e) => {
		let _code=e.target.value;
		console.log('Code now:',e.target.value);

		if(_code==""){
			setValidCode(false);
		}else{
			//setValidCode(true);
			checkCode(_code);
		}
		setFoodData({...foodData,
			['code']: e.target.value,
		})
	};
	
	function checkCode(code){
		FoodService.getByFilter({'code':code}).then(function(res){
				if(res.data.length>0){
					setValidCode(false);
				}else{
					setValidCode(true);
				}
				
		}).catch(function(error){
				console.log(error);
		});
	}
	
	//handleSendNewFoodRequest
	const handleSendNewFoodRequest = (e) => {
		//console.log('saving.....',foodData);
		if((typeof project_id !=="undefined")&&(project_id!==null)){//project filter
			foodData.global=false;
			foodData.project=project_id;
		}else{
			foodData.global=true;
			foodData.project=null;
		}
		foodData.requested=true;
		foodData.requested_by=AuthService.getCurrentUser()._id;
		foodData.created_by=null;
		foodData.processed=false;
		foodData.approved=false;
		foodData.active=false;
		
		FoodService.create(foodData).then(function(res){
				
			console.log(res.data);
			navigate("/food/view/"+res.data._id);
			navigate(0);//refresh page
				
		}).catch(function(error){
				console.log(error);
		});
	};
	
	//handleSaveNewFood
	const handleSaveNewFood = (e) => {
		console.log('saving.....',foodData);
		if(validCode || (foodData.name==!"") ){
			
			if((typeof project_id !=="undefined")&&(project_id!==null)){//project filter
				foodData.global=false;
				foodData.project=project_id;
			}else{
				foodData.global=true;
				foodData.project=null;
			}
			foodData.requested=false;
			foodData.requested_by=null;
			foodData.created_by=AuthService.getCurrentUser()._id;
			foodData.processed=true;
			foodData.approved=true;
			foodData.active=true;
			
			FoodService.create(foodData).then(function(res){
					
				console.log(res.data);
				navigate("/food/view/"+res.data._id);
				navigate(0);//refresh page
					
			}).catch(function(error){
					console.log(error);
			});
		}else{
			setErrorStatus(true);
			setErrorMessage("Please ensure that you have valid food code and name");
		}
	
	};
	
/*	const handleApproveFood = (e) => {
		console.log('approving.....',foodData);
		
			if(validCode || (foodData.name==!"") ){
				FoodService.create(foodData).then(function(res){
				
			console.log(res.data);
			navigate("/food/view/"+res.data._id);
			navigate(0);//refresh page
				
		}).catch(function(error){
				console.log(error);
		});
				
			
			{
			setErrorStatus(true);
			setErrorMessage("Please ensure that you have valid food code and name");
		}
		FoodService.create(foodData).then(function(res){
				
			console.log(res.data);
			navigate("/food/view/"+res.data._id);
			navigate(0);//refresh page
				
		}).catch(function(error){
				console.log(error);
		});
		
	};*/
	
	const handleUpdateFood = (e) => {
		console.log('updating.....',foodData);
		if(foodData.name!==""){
			
		FoodService.update(foodData).then(function(res){
				
			console.log(res.data);
			navigate("/food/view/"+res.data._id);
			navigate(0);//refresh page
				
		}).catch(function(error){
				console.log(error);
		});
		}
		else{
			setErrorStatus(true);
			setErrorMessage("Please ensure that you have valid food name");
		}
		
	};
	
	//handleApproveNewFood
	const handleApproveNewFood = (e) => {
		console.log('updating aproved.....',foodData.name);
		if(validCode || (foodData.name==!"")){
			
			foodData.processed=true;
			foodData.approved=true;
			foodData.active=true;
			
		FoodService.update(foodData).then(function(res){
				
			console.log(res.data);
			navigate("/food/view/"+res.data._id);
			navigate(0);//refresh page
				
		}).catch(function(error){
				console.log(error);
		});
		}
		else{
			setErrorStatus(true);
			setErrorMessage("Please ensure that you have valid food code and name");
		}
		
		
	};
	
	
	
	const handleCloneFood = (e) => {
		console.log('updating.....',foodData);
		FoodService.create(foodData).then(function(res){
				
			console.log(res.data);
			navigate("/food/view/"+res.data._id);
			navigate(0);//refresh page
				
		}).catch(function(error){
				console.log(error);
		});
		
	};
	
	///handleSendCopyFoodRequest
	
	const handleSendCopyFoodRequest = (e) => {
		//console.log('saving.....',foodData);
		
		if(foodData.name!==""){
			
		if((typeof project_id !=="undefined")&&(project_id!==null)){//project filter
			foodData.global=false;
			foodData.project=project_id;
		}else{
			foodData.global=true;
			foodData.project=null;
		}
		foodData.requested=true;
		foodData.requested_by=AuthService.getCurrentUser()._id;
		foodData.created_by=null;
		foodData.processed=false;
		foodData.approved=false;
		foodData.active=false;
		
		FoodService.create(foodData).then(function(res){
				
			console.log(res.data);
			navigate("/food/view/"+res.data._id);
			navigate(0);//refresh page
				
		}).catch(function(error){
				console.log(error);
		});
		
		}else{
			setErrorStatus(true);
			setErrorMessage("Please ensure that you have valid food code and name");
		}
	};
	
	const handleCopyFood = (e) => {
		console.log('copying.....',foodData);
		
		if(validCode || (foodData.name==!"") ){
			
			if((typeof project_id !=="undefined")&&(project_id!==null)){//project filter
				foodData.global=false;
				foodData.project=project_id;
			}else{
				foodData.global=true;
				foodData.project=null;
			}
			foodData.requested=false;
			foodData.requested_by=null;
			foodData.created_by=AuthService.getCurrentUser()._id;
			foodData.processed=true;
			foodData.approved=true;
			foodData.active=true;
			
			FoodService.create(foodData).then(function(res){
					
				console.log(res.data);
				navigate("/food/view/"+res.data._id);
				navigate(0);//refresh page
					
			}).catch(function(error){
					console.log(error);
			});
		}else{
			setErrorStatus(true);
			setErrorMessage("Please ensure that you have valid food code and name");
		}
		/*FoodService.create(foodData).then(function(res){
				
			console.log(res.data);
			navigate("/food/view/"+res.data._id);
			navigate(0);//refresh page
				
		}).catch(function(error){
				console.log(error);
		});*/
		
	};
	
	//generate food template
	function createTemplate(translations){
		//name
		setTempFoodData(prevState => ({
			...prevState,
			'name': '',
		}))
		//code
		setTempFoodData(prevState => ({
			...prevState,
			'code': '',
		}))
		//code
		setTempFoodData(prevState => ({
			...prevState,
			'group': '',
		}))
		//rest of variables
		for (let key in removeKeys(translations,['code','name','group'])) {
			//console.log(key+'=>'+translations[key]);
			setTempFoodData(prevState => ({
				...prevState,
				[key]: 0,
			}))
		}
	}
	
	/* smart portions */
	/*function loadSmartPortionsById(food_code){
			MeasurementService.getByFilter({'food_code':food_code}).then(function(res){
				console.log('smart potions',res.data);
				setSmartPortionData(res.data);
				//var _food=res.data;
				//setFoodData(res.data);
				//if(methodType=='Clone'){
				//	delete _food['_id']; 
				//	delete _food['name']; 
					//_food.code =_food.code+'_1';
				//}
				//console.log(_food);
			//	setFoodFound(true);
			}).catch(function(error){
					console.log(error);
					//setFoodFound(false);
			});
		}*/
		
	function getImageUrl(id){
		return SmartPortionService.getImageUrl(id);
	}
	
	const [spWeight,setSpWeight]=useState(0);	
	const handleClick = (e,value) => {
			console.log('value',value);
			setSpWeight(value);
			setOpenSmartPortionDialog(true);
	};
	
  return(
  <>
    {globalSettingsLoaded ?
	<>
	<TopPrivateNavigation/>
	<AppLogout>
	<br/>
	{(projectFound) ?
	<>
	<Breadcrumbs aria-label="breadcrumb">
        <Link underline="hover" color="inherit" href="/"> Home </Link>
		<Link
          underline="hover"
          color="inherit"
          href="/projects"
        >
          Projects
        </Link>
		<Link
          underline="hover"
          color="inherit"
          href={`/project/${projectData._id}`}
        >
          {projectData.name}
        </Link>

		 <Link underline="hover" color="inherit" href={`/foods`} > Foods </Link>
		<Typography color="text.primary">{methodType} food</Typography>
      </Breadcrumbs>
	
	</>
	:<>
	<Breadcrumbs aria-label="breadcrumb">
        <Link underline="hover" color="inherit" href="/"> Home </Link>
		 <Link underline="hover" color="inherit" href="/foods" > Foods  </Link>
		<Typography color="text.primary">{methodType} food</Typography>
      </Breadcrumbs>
	</>}
	
	  
	<br/>
	  <Divider />
	<br/>
	{ ShowErrorMessage &&
		<Alert variant="filled" severity="error">{ErrorText}</Alert>
	} 
	{ ShowSuccessMessage &&
		<Alert variant="filled" severity="success">{SuccessText}</Alert>
	}
	
	
	{/*NEW*/}
	{(methodType=='New') ?
	<>

	<div style={{ width: '100%' }}>
		<Box sx={{ display: 'flex', flexDirection: 'row-reverse', p: 1,  m: 1,  borderRadius: 1, }}  >
	  
	  	{/* Master */}
		{(currentUser.__t=='Master') ?
		<>
			  
        <Button  onClick={handleSaveNewFood}  variant="contained" endIcon={<SaveIcon/>}>
		  Save
		</Button>
		
		</>
		:<></>}
		
		{/* Researcher */}
		{(currentUser.__t=='Researcher') ?
		<>
			  
        <Button  onClick={handleSendNewFoodRequest}  variant="contained" endIcon={<SendIcon/>}>
		  Send Request
		</Button>
		
		</>
		:<></>}
		  

      </Box>
    </div>
	
	
	 <TableContainer component={Paper}>
      <Table sx={{ minWidth: 650 }} aria-label="simple table">
		  {/*<TableHead>
          <TableRow>
            <TableCell>Typical Values</TableCell>
            <TableCell align="left">Per 100g</TableCell>
          </TableRow>
	</TableHead>*/}
        <TableBody>
		<TableRow
             
              sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
            >
			{/* <TableCell component="th" scope="row">
                Code
	</TableCell>*/}
	
		{/* Only Master account to give new food a code */}
		{(currentUser.__t=='Master') ?
		<>
              <TableCell align="left">
			  <br/>
			  {/* valid food code*/}
			<TextField onChange={(e) => {handleOnChangeCode(e)}} value={foodData['code']}  id="standard-basic" label="Code" variant="standard" />
			{validCode && <><Typography variant="caption" gutterBottom sx={{ display: 'block',color:'green' }}>Valid Code</Typography></>}
			{!validCode && <><Typography variant="caption" gutterBottom sx={{ display: 'block',color:'red' }}>Not Valid</Typography></>}
			 
			  </TableCell>
			</>
		:<></>}  
			  
			  
            </TableRow>
			<TableRow
             
              sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
            >
			{/* <TableCell component="th" scope="row">
                Name
	</TableCell>*/}
              <TableCell align="left">
			  <TextField onChange={(e) => {handleOnChangeValue(e,'name')}} value={foodData['name']} id="standard-basic" label="Name" variant="standard" />
	 
			  </TableCell>
			  
            </TableRow>
			
			<TableRow
             
              sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
            >
			{/* <TableCell component="th" scope="row">
                Name
	</TableCell>*/}
              <TableCell align="left">
			  <TextField onChange={(e) => {handleOnChangeValue(e,'group')}} value={foodData['group']} id="standard-basic" label="Food Group" variant="standard" />
	 
			  </TableCell>
			  
            </TableRow> 
			
          {Object.entries(removeKeys(foodTranslations,['code','name','group'])).map(([key, value]) => ( 
            <TableRow
              key={key}
              sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
            >
			{/* <TableCell component="th" scope="row">
                {value}
		  </TableCell>*/}
              <TableCell align="left">
			  
			  <TextField onChange={(e) => {handleOnChangeValue(e,key)}} value={foodData[key]} id="standard-basic" label={value} variant="standard" />
			  
			  </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
		<br/><br/>
	</>
	:(methodType=='View') ?	
	<>{/* VIEW */}
	{/* error no food found */}
	{(!foodFound) ?
		<>
		No food found
		
		</>
	:<></>}
	{/* if food is found */}
	{(foodFound) ?
		<>
		<div style={{ width: '100%' }}>
		<Box
        sx={{
          display: 'flex',
          flexDirection: 'row-reverse',
          p: 1,
          m: 1,
         // bgcolor: 'background.paper',
          borderRadius: 1,
        }}
      >
	  
	  	{/* Master */}
		{(currentUser.__t=='Master') ?
		<>
			  
        <Button href={`/food/edit/${foodData._id}`}  variant="contained" endIcon={<EditIcon/>}>
		  Edit
		</Button>
		
		</>
		:<></>}
		
		{/* Researcher */}
		{(currentUser.__t=='Researcher') ?
		<>
		
        <Button href={`/food/edit/${foodData._id}`}   variant="contained" endIcon={<EditIcon/>}>
		  Edit
		</Button>
		
		</>
		:<></>}
		  

      </Box>
    </div>
		
	<br/>
	
	
	{/* Researcher */}
		{(currentUser.__t=='Researcher') ?
		<>

		{(foodData.requested)?
		<>
			{(foodData.processed) ?
			<>
			  
			</>
			:<>
			<Alert severity="info">Awaiting approval.</Alert>
			</>}
			
		</>
		:<>
		</>}
		
		</>
		:<></>}

	<br/>
		<Typography variant="h5" gutterBottom>
			{foodData.code} - {foodData.name}
		</Typography>
		<b>Food Group:</b> {foodData.group}
		
		<Typography variant="h6" gutterBottom>
			Nutritional Information
		</Typography>
		<TableContainer component={Paper}>
      <Table sx={{ minWidth: 650 }} aria-label="simple table">
        <TableHead>
          <TableRow>
            <TableCell>Typical Values</TableCell>
            <TableCell align="left">Per 100g</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {Object.entries(removeKeys(foodTranslations,['code','name','group'])).map(([key, value]) => ( 
            <TableRow
              key={key}
              sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
            >
              <TableCell component="th" scope="row">
                {value}
              </TableCell>
              <TableCell align="left">
				
			  {foodData[key]}
			  
			  </TableCell>
			  
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
		<br/><br/>
			{modulesEnabled['smart_portions'] &&
			<>
			{/*{smartPortion.found &&
				<>*/}
					<Typography variant="h3" gutterBottom>Smart Portions</Typography>
					<SmartPortionComponent smartPortionLoaded={smartPortionLoaded} smartPortion={smartPortion} onClick={handleClick}  />
						{/*</>}*/}
			</>}
			<Dialog
			open={openSmartPortionDialog}
			onClose={handleSmartPortionClose}
			aria-labelledby="alert-dialog-title"
			aria-describedby="alert-dialog-description"
		  >
			<DialogTitle id="alert-dialog-title">Smart Portion weight(g)</DialogTitle>
			<DialogContent>
			  <DialogContentText id="alert-dialog-description">
			  {spWeight}
			  </DialogContentText>
			</DialogContent>
			<DialogActions>
			  <Button onClick={handleSmartPortionClose} color="primary" autoFocus>
				Close
			  </Button>
			</DialogActions>
		  </Dialog>
		  
			{/*		{smartPortionLoaded &&
			<>
				<Typography variant="h5" gutterBottom>HHM</Typography>
				{smartPortion.sp.hhm_exists &&
				<>
					<TableContainer component={Paper}>
					 <Table sx={{ minWidth: 650 }} aria-label="simple table">
						<TableHead>
						  <TableRow>
							<TableCell>Code</TableCell>
							<TableCell align="left">Name</TableCell>
							<TableCell align="left">Volume</TableCell>
							<TableCell align="left">Fractions</TableCell>
						  </TableRow>
						</TableHead>
						<TableBody>
						   {smartPortion['hhm'].map((row,index) => (
							<TableRow
							  key={index}
							  sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
							>
							  <TableCell component="th" scope="row">
								{row.code}
							  </TableCell>
							  <TableCell align="left">
								
								{row.name}
							  </TableCell>
							   <TableCell align="left">
							{row.volume}
							  </TableCell>
							  <TableCell align="left">
							{row['fractions'].map((f,i) => (
							<>
							<span key={i}>
							{f} ({formatFractions(row.volume,f)})<br/>
							</span>
							</>
							))}
							  </TableCell>
							  
							</TableRow>
						  ))}
						</TableBody>
					  </Table>
					</TableContainer>

				</>}
				
				{!smartPortion.sp.hhm_exists &&
				<>
					None
				</>
				}
				
				<br/>
				<Typography variant="h5" gutterBottom>Images</Typography>
				{smartPortion.sp.images_exists &&
				<>
					<TableContainer component={Paper}>
						 <Table sx={{ minWidth: 650 }} aria-label="simple table">
							<TableHead>
							  <TableRow>
								<TableCell align="left"></TableCell>
								<TableCell align="left">Image</TableCell>
								<TableCell align="left">Volume</TableCell>
								<TableCell align="left">Weight</TableCell>
							  </TableRow>
							</TableHead>
							<TableBody>
							   {smartPortion['images'].map((row,index) => (
								<TableRow
								  key={index}
								  sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
								>
								  <TableCell component="th" scope="row">
								  {row.title}<br/>{row.description}
								  </TableCell>
								  <TableCell align="left">
									<img src={`${getImageUrl(row.img.id)}`}></img>
								  </TableCell>
								   <TableCell align="left">
									{row['description_array'].map((v,i) => (
									<>
									<span key={i}>
										{v}--{row['volume'][i]}<br/>
									</span>
									</>
									))}
								  </TableCell>
								  <TableCell align="left">
									{row['weight'].map((w,i) => (
									<>
									<span key={i}>
									{w}<br/>
									</span>
									</>
									))}
								  </TableCell>
								  
								</TableRow>
							  ))}
							</TableBody>
						  </Table>
						</TableContainer>
				</>}
			
				{!smartPortion.sp.images_exists &&
				<>
				None
				</>}
				<br/>
				
				<Typography variant="h5" gutterBottom>Standard Portions</Typography>
				{smartPortion.sp.standard_exists &&
				<>
						<TableContainer component={Paper}>
						 <Table sx={{ minWidth: 650 }} aria-label="simple table">
							<TableHead>
							  <TableRow>
								<TableCell align="left">Description</TableCell>
								<TableCell align="left">Volume</TableCell>
								<TableCell align="left">Weight</TableCell>
							  </TableRow>
							</TableHead>
							<TableBody>
							   {smartPortion['standard'].map((row,index) => (
								<TableRow
								  key={index}
								  sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
								>
								  <TableCell component="th" scope="row">
								  {row.title}<br/>{row.description}
								  </TableCell>
								
								   <TableCell align="left">
									{row.volume}
								  </TableCell>
								  <TableCell align="left">
									{row.weight}
								  </TableCell>
								  
								</TableRow>
							  ))}
							</TableBody>
						  </Table>
						</TableContainer>
				</>}
			
				{!smartPortion.sp.standard_exists &&
				<>
				None
				</>}
			
	</>}*/}
			
	
			
		{/*<TableContainer component={Paper}>
      <Table sx={{ minWidth: 650 }} aria-label="simple table">
        <TableHead>
          <TableRow>
            <TableCell></TableCell>
            <TableCell align="left">Image</TableCell>
            <TableCell align="left">Value g</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
           {smartPortionData.map((row,index) => (
            <TableRow
              key={index}
              sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
            >
              <TableCell component="th" scope="row">
                {index}
              </TableCell>
              <TableCell align="left">
				<img src={`${getImageUrl(row.img_name)}`}></img>
					{formatJson(row.img_details)}
			  </TableCell>
			   <TableCell align="left">
			   {row.value}
			  </TableCell>
			  
            </TableRow>
          ))}
        </TableBody>
      </Table>
		</TableContainer>*/}
		</>
	:<></>}
	
	</>
	:(methodType=='Edit') ?
	<>
		<div style={{ width: '100%' }}>
		<Box
        sx={{
          display: 'flex',
          flexDirection: 'row-reverse',
          p: 1,
          m: 1,
         // bgcolor: 'background.paper',
          borderRadius: 1,
        }}
      >
	  
	  	{/* Master */}
		{(currentUser.__t=='Master') ?
		<>
		
		{(foodData.approved)?
			<>
			<Button  onClick={handleUpdateFood}  variant="contained" endIcon={<SaveIcon/>}>
			  Save
			</Button>
			</>:<>
				<Alert severity="info">Awaiting your approval.</Alert>
			</>}
		
		{/*{(foodData.requested)?
			<>
				{(foodData.processed) ?
				<>
				  
				</>
				:<>
				<Alert severity="info">Awaiting your approval.</Alert>
				</>}
				
			</>
			:<>
			
			  <Button  onClick={handleUpdateFood}  variant="contained" endIcon={<SaveIcon/>}>
				  Save
			</Button>
		</>}*/}
			  
      
		
		</>
		:<></>}
		
		{/* Researcher */}
		{(currentUser.__t=='Researcher') ?
		<>
			
			
			{(foodData.approved)?
			<>
			<Button  onClick={handleUpdateFood}  variant="contained" endIcon={<SaveIcon/>}>
			  Save
			</Button>
			</>:<>
				<Alert severity="info">Awaiting approval.</Alert>
			</>}
		{/*{(foodData.requested)?
			<>
				{(foodData.processed) ?
				<>
				  
				</>
				:<>
				<Alert severity="info">Awaiting your approval.</Alert>
				</>}
				
			</>
			:<>
			
			   <Button  onClick={handleUpdateFood}  variant="contained" endIcon={<SaveIcon/>}>
		  Save
		</Button>
		</>}*/}
			  
       
		
		</>
		:<></>}
		  

      </Box>
	  
	
		<br/>
    </div>
	
		{(!foodFound) ?
			<>No food found</>
		:<>
		
		<Typography variant="h6" gutterBottom>
			Nutritional Information
		</Typography>
		 <TableContainer component={Paper}>
      <Table sx={{ minWidth: 650 }} aria-label="simple table">
		  {/*<TableHead>
          <TableRow>
            <TableCell>Typical Values</TableCell>
            <TableCell align="left">Per 100g</TableCell>
          </TableRow>
	</TableHead>*/}
        <TableBody>
		<TableRow
             
              sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
            >
			{/* <TableCell component="th" scope="row">
                Code
	</TableCell>*/}
	
		{/* Master */}
		{(currentUser.__t=='Master') ?
		<>
              <TableCell align="left">
			  <TextField onChange={(e) => {handleOnChangeValue(e,'code')}} disabled value={foodData['code']} id="standard-basic" label="Code" variant="standard" />
	 
			  </TableCell>
			</>
		:<></>}  
			  
			  
            </TableRow>
			<TableRow
             
              sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
            >
			{/* <TableCell component="th" scope="row">
                Name
	</TableCell>*/}
              <TableCell align="left">
			  <TextField onChange={(e) => {handleOnChangeValue(e,'name')}} value={foodData['name']} id="standard-basic" label="Name" variant="standard" />
	 
			  </TableCell>
			  
            </TableRow>
			
			<TableRow
             
              sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
            >
			{/* <TableCell component="th" scope="row">
                Name
	</TableCell>*/}
              <TableCell align="left">
			  <TextField onChange={(e) => {handleOnChangeValue(e,'group')}} value={foodData['group']} id="standard-basic" label="Food Group" variant="standard" />
	 
			  </TableCell>
			  
            </TableRow>
          {Object.entries(removeKeys(foodTranslations,['code','name','group'])).map(([key, value]) => ( 
            <TableRow
              key={key}
              sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
            >
			{/* <TableCell component="th" scope="row">
                {value}
		  </TableCell>*/}
              <TableCell align="left">
			  <TextField onChange={(e) => {handleOnChangeValue(e,key)}} value={foodData[key]} id="standard-basic" label={value} variant="standard" />
			  </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
		<br/><br/>
		
		
		
		</>}
	
	</>
	:(methodType=='Clone') ?
		<>

		<div style={{ width: '100%' }}>
		<Box
        sx={{
          display: 'flex',
          flexDirection: 'row-reverse',
          p: 1,
          m: 1,
         // bgcolor: 'background.paper',
          borderRadius: 1,
        }}
      >
	  
	
	  
	  	{/* Master */}
		{(currentUser.__t=='Master') ?
		<>  
			<Button  onClick={handleCopyFood}  variant="contained" endIcon={<SaveIcon/>}>
				Save
			</Button>
		
		</>
		:<></>}
		
		{/* Researcher */}
		{(currentUser.__t=='Researcher') ?
		<>
			  
        <Button  onClick={handleSendCopyFoodRequest}  variant="contained" endIcon={<SendIcon/>}>
		  Send Request
		</Button>
		
		</>
		:<></>}
		  

      </Box>
    </div>
	
	
	 <TableContainer component={Paper}>
      <Table sx={{ minWidth: 650 }} aria-label="simple table">
        <TableBody>
		<TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }} >
				{/* Master */}
				{(currentUser.__t=='Master') ?
				<>
				<TableCell align="left">
				   {/* valid food code*/}
			<TextField onChange={(e) => {handleOnChangeCode(e)}} value={foodData['code']}  id="standard-basic" label="Code" variant="standard" />
			{validCode && <><Typography variant="caption" gutterBottom sx={{ display: 'block',color:'green' }}>Valid Code</Typography></>}
			{!validCode && <><Typography variant="caption" gutterBottom sx={{ display: 'block',color:'red' }}>Not Valid</Typography></>}
			 

				 </TableCell>
					</>
				:<></>} 
			
            </TableRow>
			<TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }} >
              <TableCell align="left">
			  <TextField onChange={(e) => {handleOnChangeValue(e,'name')}} value={foodData['name']} id="standard-basic" label="Name" variant="standard" />
			  </TableCell>
            </TableRow>
			
			<TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }} >
              <TableCell align="left">
			  <TextField onChange={(e) => {handleOnChangeValue(e,'group')}} value={foodData['group']} id="standard-basic" label="Food Group" variant="standard" />
			  </TableCell>
            </TableRow>
			
          {Object.entries(removeKeys(foodTranslations,['code','name','group'])).map(([key, value]) => ( 
            <TableRow  key={key} sx={{ '&:last-child td, &:last-child th': { border: 0 } }} >
              <TableCell align="left">
			  <TextField onChange={(e) => {handleOnChangeValue(e,key)}} value={foodData[key]} id="standard-basic" label={value} variant="standard" />
			  </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
	<br/><br/>
	
	
	
	
	
	</>
	:(methodType=='Copy') ?
		
	<>
	
	<div style={{ width: '100%' }}>
		<Box
        sx={{
          display: 'flex',
          flexDirection: 'row-reverse',
          p: 1,
          m: 1,
         // bgcolor: 'background.paper',
          borderRadius: 1,
        }}
      >
	  
	
	  
	  	{/* Master */}
		{(currentUser.__t=='Master') ?
		<>  
			<Button  onClick={handleCopyFood}  variant="contained" endIcon={<SaveIcon/>}>
				Save
			</Button>
		
		</>
		:<></>}
		
		{/* Researcher */}
		{(currentUser.__t=='Researcher') ?
		<>
			  
        <Button  onClick={handleSendCopyFoodRequest}  variant="contained" endIcon={<SendIcon/>}>
		  Send Request
		</Button>
		
		</>
		:<></>}
		  

      </Box>
    </div>
	
	
	 <TableContainer component={Paper}>
      <Table sx={{ minWidth: 650 }} aria-label="simple table">
        <TableBody>
		<TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }} >
				{/* Master */}
				{(currentUser.__t=='Master') ?
				<>
				<TableCell align="left">
				   {/* valid food code*/}
			<TextField onChange={(e) => {handleOnChangeCode(e)}} value={foodData['code']}  id="standard-basic" label="Code" variant="standard" />
			{validCode && <><Typography variant="caption" gutterBottom sx={{ display: 'block',color:'green' }}>Valid Code</Typography></>}
			{!validCode && <><Typography variant="caption" gutterBottom sx={{ display: 'block',color:'red' }}>Not Valid</Typography></>}
			 

				 </TableCell>
					</>
				:<></>} 
			
            </TableRow>
			<TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }} >
              <TableCell align="left">
			  <TextField onChange={(e) => {handleOnChangeValue(e,'name')}} value={foodData['name']} id="standard-basic" label="Name" variant="standard" />
			  </TableCell>
            </TableRow>
			
			<TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }} >
              <TableCell align="left">
			  <TextField onChange={(e) => {handleOnChangeValue(e,'group')}} value={foodData['group']} id="standard-basic" label="Food Group" variant="standard" />
			  </TableCell>
            </TableRow>
			
          {Object.entries(removeKeys(foodTranslations,['code','name','group'])).map(([key, value]) => ( 
            <TableRow  key={key} sx={{ '&:last-child td, &:last-child th': { border: 0 } }} >
              <TableCell align="left">
			  <TextField onChange={(e) => {handleOnChangeValue(e,key)}} value={foodData[key]} id="standard-basic" label={value} variant="standard" />
			  </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
	<br/><br/>
	
	
	
	
	</>
	:(methodType=='Approve') ?
	<>
	
	<div style={{ width: '100%' }}>
		<Box
        sx={{
          display: 'flex',
          flexDirection: 'row-reverse',
          p: 1,
          m: 1,
         // bgcolor: 'background.paper',
          borderRadius: 1,
        }}
      >
	  
	  	{/* Master */}
		{(currentUser.__t=='Master') ?
		<>
			  
        <Button  onClick={handleApproveNewFood}  variant="contained" endIcon={<SaveIcon/>}>
		  Approve
		</Button>
		
		</>
		:<></>}

		  

      </Box>
    </div>
	
	
	{(!foodFound) ?
			<>No food found</>
		:<>
		
		<Typography variant="h6" gutterBottom>
			Nutritional Information
		</Typography>
		 <TableContainer component={Paper}>
      <Table sx={{ minWidth: 650 }} aria-label="simple table">
		  {/*<TableHead>
          <TableRow>
            <TableCell>Typical Values</TableCell>
            <TableCell align="left">Per 100g</TableCell>
          </TableRow>
	</TableHead>*/}
        <TableBody>
		<TableRow
             
              sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
            >
			{/* <TableCell component="th" scope="row">
                Code
	</TableCell>*/}
	
		{/* Master */}
		{(currentUser.__t=='Master') ?
		<>
              <TableCell align="left">
			    {/* valid food code*/}
			<TextField onChange={(e) => {handleOnChangeCode(e)}} value={foodData['code']}  id="standard-basic" label="Code" variant="standard" />
			{validCode && <><Typography variant="caption" gutterBottom sx={{ display: 'block',color:'green' }}>Valid Code</Typography></>}
			{!validCode && <><Typography variant="caption" gutterBottom sx={{ display: 'block',color:'red' }}>Not Valid</Typography></>}
			 
			  </TableCell>
			</>
		:<></>}  
			  
			  
            </TableRow>
			<TableRow
             
              sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
            >
			{/* <TableCell component="th" scope="row">
                Name
	</TableCell>*/}
              <TableCell align="left">
			  <TextField onChange={(e) => {handleOnChangeValue(e,'name')}} value={foodData['name']} id="standard-basic" label="Name" variant="standard" />
	 
			  </TableCell>
			  
            </TableRow>
			
			<TableRow
             
              sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
            >
			{/* <TableCell component="th" scope="row">
                Name
	</TableCell>*/}
              <TableCell align="left">
			  <TextField onChange={(e) => {handleOnChangeValue(e,'group')}} value={foodData['group']} id="standard-basic" label="Food Group" variant="standard" />
	 
			  </TableCell>
			  
            </TableRow>
          {Object.entries(removeKeys(foodTranslations,['code','name','group'])).map(([key, value]) => ( 
            <TableRow
              key={key}
              sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
            >
			{/* <TableCell component="th" scope="row">
                {value}
		  </TableCell>*/}
              <TableCell align="left">
			  <TextField onChange={(e) => {handleOnChangeValue(e,key)}} value={foodData[key]} id="standard-basic" label={value} variant="standard" />
			  </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
		<br/><br/>
		
		
		
		</>}
	
	
	
	
	</>
	:<>Other</>}
	
	
	{/* Admin */}
	{(currentUser.__t=='Admin') ?
	<>
	
	</>
	:<></>}
	
	{/* Master */}
	{(currentUser.__t=='Master') ?
	<>
	
	</>
	:<></>}
	
	{/* Researcher */}
	{(currentUser.__t=='Researcher') ?
	<>
	
	</>
	:<></>}

	</AppLogout>
	</>:<>
 <CircularProgress />
  </>}
	</>
  ) 
  ;
};

export default Food;